<template>
  <div>
    <div v-if="loading" class="app-content-column">
      <Spinner />
    </div>

    <div v-if="!loading">
      <Subheader :title="event.title" />

      <div class="app-content-column">
        <div class="card-custom centered-block">
          <img :src="event.photo" :alt="event.title + ' photo'" />

          <div class="card-content-container">
            <h5>{{ event.title }}</h5>
            <p>{{ event.date | eventDate }}</p>
            <p>{{ event.fullDescription }}</p>
          </div>

          <img v-for="p in event.secondaryPhotos" :key="p.id" :src="p.image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { errorMessage } from '@/services/utils/apiErrors'
import Event from '@/services/events'

import Subheader from '@/components/Subheader'
import Spinner from '@/components/Spinner'

export default {
  name: 'EventDetails',
  components: {
    Subheader,
    Spinner,
  },
  filters: {
    eventDate: function(date) {
      return moment(date).format('DD.MM.YYYY HH:MM')
    },
  },
  data() {
    return {
      event: Event.create(),
      loading: false,
    }
  },
  async created() {
    this.event.id = this.$route.params.eventId
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      this.loading = true

      try {
        const eventResponse = await Event.api.retrieve(this.event.id)
        this.event = eventResponse
      } catch {
        errorMessage()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/forms';
@import '../styles/mixins/buttons';

.card-custom {
  margin: 1.25rem;

  background-color: #ffffff;
  border-radius: 0.25rem;
  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    background-color: rgba($primary, 0.7);

    &:not(:last-of-type) {
      margin-bottom: 1rem;
    }
  }

  .card-content-container {
    padding: 1.5rem;
  }
}

.centered-block {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>
